export default __webpack_public_path__ + "static/media/Gallery_2.0a730345.jpg";